// extracted by mini-css-extract-plugin
export default {"notePreview":"NotePreview_notePreview__N7PSD","row":"NotePreview_row__3-yqm","rowHeader":"NotePreview_rowHeader__KvoE+","rowPreview":"NotePreview_rowPreview__65P8g"};